import Facade from '@/Facade'

export class PlatformUtil {
    public static isWebGLSupported(): boolean {
        const contextOptions = {
            failIfMajorPerformanceCaveat: true,
            stencil: true,
        }

        try {
            if (window.WebGLRenderingContext == null) {
                return false
            }

            const element = document.createElement('canvas')
            const context = (element.getContext('webgl', contextOptions) ||
                element.getContext('experimental-webgl', contextOptions)) as WebGLRenderingContext
            const success = context != null && context.getContextAttributes().stencil

            if (context != null) {
                const loseContext = context.getExtension('WEBGL_lose_context')

                if (loseContext != null) {
                    loseContext.loseContext()
                }
            }

            return success
        } catch (error) {
            // ignoring error
        }

        return false
    }

    public static isFormatSupported(format: string): boolean {
        try {
            const element = document.createElement('canvas')
            const context = element.getContext('2d')

            if (context != null) {
                return element.toDataURL(format).startsWith('data:' + format)
            }
        } catch (error) {
            // ignoring error
        }

        return false
    }

    public static isSafariBrowser(): boolean {
        const userAgent = navigator.userAgent.toLowerCase()

        if (userAgent.indexOf('safari') !== -1) {
            return userAgent.indexOf('chrome') === -1
        }

        return false
    }

    public static getLobbyURL() {
        const lobbyURL = ''

        if (lobbyURL != null && lobbyURL.length > 0) {
            return lobbyURL
        }

        if (window.parent !== window) {
            return document.referrer
        }

        return location.href
    }
}
